import { useSelector } from 'react-redux';
import { detectedCountryCodeSelector } from '../redux';
export var useCountryDetection = function () {
    var detectedCountryCode = useSelector(detectedCountryCodeSelector);
    var isItaly = detectedCountryCode === 'IT';
    return {
        detectedCountryCode: detectedCountryCode,
        isItaly: isItaly,
    };
};
